import { ReactElement, useMemo, useCallback } from 'react';

import { AdminReportItemsInProgressCompany } from '~services/admin/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';
import { getDefaultAvatar } from '~utils/user';
import { DEFAULT_UUIID_EMPTY } from '~constants/commons';

import { useDashboardVariantV2CarrierContentInTransitTrackingContext } from '../../../Context';

type CompaniesDeliveryExtraData = Pick<
  AdminReportItemsInProgressCompany,
  'companyId' | 'giverCompanyId'
>;

const DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabCompanies =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedCompany: {
          value: selectedCompany,
          setValue: setSelectedCompany,
        },
      },
    } = useDashboardVariantV2CarrierContentInTransitTrackingContext();

    const companiesDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<CompaniesDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.itemsInProgressByCompany) return [];

      return tabsData.itemsInProgressByCompany.map((company) => ({
        label: company.name,
        totalCount: company.totalItemsInProgress,
        standarCount: company.totalItemsInProgressNoFlex,
        flexCount: company.totalItemsInProgressFlex,
        avatar: {
          src: getDefaultAvatar(company.logoUrl || undefined),
          alt: company.name,
        },
        extraData: {
          companyId: company.companyId,
          giverCompanyId: company.giverCompanyId,
        },
        isSelected:
          company.companyId === DEFAULT_UUIID_EMPTY
            ? selectedCompany?.giverCompanyId === company.giverCompanyId
            : selectedCompany?.companyId === company.companyId,
      }));
    }, [tabsData?.itemsInProgressByCompany, selectedCompany]);

    const handleClickItem = useCallback(
      (extraData: CompaniesDeliveryExtraData) => {
        setSelectedCompany(extraData);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={companiesDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabCompanies;
